import { EventEmitter, Output } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RefundActionTypeEnum } from "../../_models";
import * as moment from "moment";
import * as _ from "lodash";

export class RefundBaseComponent extends BaseComponent {
  @Output() onRefundCompleted: EventEmitter<any> = new EventEmitter<any>();
  formGroupObj: FormGroup;
  formGroupConfirmObj: FormGroup;
  dateNow: string = moment(Date.now()).format("YYYY-MM-DD HH:mm");
  cashierStatuses: any = [];
  refundActionTypes: any = [];
  refundActionTypesObj = RefundActionTypeEnum;
  errorMessage: string;

  run() {
    this.cashierStatuses = JSON.parse(localStorage.getItem("cashierStatuses"));
    if (this.base.user.hasRefundCode) {
      this.refundActionTypes.push(RefundActionTypeEnum.APPROVE);
      this.refundActionTypes.push(RefundActionTypeEnum.DENY);
      this.refundActionTypes.push(RefundActionTypeEnum.COMMENT);

      if (
        this.base.user.counties.filter((county) => county.name === "ALL")
          .length > 0
      ) {
        this.refundActionTypes.push(RefundActionTypeEnum.RENEW);
      }

      this.formGroupObj = new FormGroup({
        comment: new FormControl(null, Validators.required),
        amount: new FormControl(null, [
          Validators.required,
          Validators.max(50000),
        ]),
        note: new FormControl(
          null,
          this.base.user.counties.filter((county) => county.name === "ALL")
            .length === 0 && Validators.required
        ),
        status: new FormControl(null, Validators.required),
      });
    } else {
      this.refundActionTypes.push(RefundActionTypeEnum.COMMENT);
      this.formGroupObj = new FormGroup({
        comment: new FormControl(null, Validators.required),
        status: new FormControl(null, Validators.required),
      });
    }
    this.formGroupConfirmObj = new FormGroup({
      refundAdminCode: new FormControl(null, Validators.required),
    });
  }

  submit(paymentReturn) {
    this.errorMessage = undefined;
    if (!this.loading) {
      const postDataRefundData = _.merge(
        paymentReturn ? paymentReturn : {},
        { items: paymentReturn ? [paymentReturn.itemId] : [] },
        this.formGroupObj.getRawValue(),
        this.formGroupConfirmObj.getRawValue()
      );
      const postData = {
        refundData: postDataRefundData,
        isSingleItem: true,
      };
      this.loading = true;
      this.dataService.postEntity("refund-payments", postData).subscribe(
        (data) => {
          this.loading = false;
          if (data && data.result && data.result.length > 0) {
            const res = data.result[0];
            if (res && res.code >= 0) {
              this.onSuccess(
                "טופל בהצלחה " + res.eventName + " " + res.childName + "!"
              );
              this.formGroupObj.reset();
              this.onRefundCompleted.emit();
            } else if (res && res.message) {
              this.errorMessage = res.message;
              this.onFailed(res.message);
            }
          }
        },
        (error) => {
          this.loading = false;
          const body = error.json && error.json();
          this.errorMessage =
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error;
        }
      );
    }
  }

  onSuccess(message) {
    throw new Error("onSuccess not implemented ");
  }

  onFailed(message) {
    throw new Error("onFailed not implemented ");
  }

  clearFormObj() {
    this.formGroupObj.reset();
    if (this.formGroupConfirmObj) {
      this.formGroupConfirmObj.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/payments_refunds/refund-base.component.ts